var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgentStatusUpgrade(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 6.857,
    fill: "#157FF3",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0a8 8 0 10.001 16.001A8 8 0 008 0zm0 14.643A6.644 6.644 0 018 1.357a6.644 6.644 0 010 13.286z",
    fill: "#157FF3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 8h1.333L7.5 5.915V12h1V5.915L10.667 8H12L8 4 4 8z",
    fill: "#157FF3"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8Y2lyY2xlIGN4PSI4IiBjeT0iOCIgcj0iNi44NTcxNCIgZmlsbD0iIzE1N0ZGMyIgZmlsbC1vcGFjaXR5PSIwLjA1Ii8+CiAgPHBhdGggZD0iTTggMEMzLjU4MjE0IDAgMCAzLjU4MjE0IDAgOEMwIDEyLjQxNzkgMy41ODIxNCAxNiA4IDE2QzEyLjQxNzkgMTYgMTYgMTIuNDE3OSAxNiA4QzE2IDMuNTgyMTQgMTIuNDE3OSAwIDggMFpNOCAxNC42NDI5QzQuMzMyMTQgMTQuNjQyOSAxLjM1NzE0IDExLjY2NzkgMS4zNTcxNCA4QzEuMzU3MTQgNC4zMzIxNCA0LjMzMjE0IDEuMzU3MTQgOCAxLjM1NzE0QzExLjY2NzkgMS4zNTcxNCAxNC42NDI5IDQuMzMyMTQgMTQuNjQyOSA4QzE0LjY0MjkgMTEuNjY3OSAxMS42Njc5IDE0LjY0MjkgOCAxNC42NDI5WiIgZmlsbD0iIzE1N0ZGMyIvPgogIDxwYXRoIGQ9Ik00IDhINS4zMzMzM0w3LjUgNS45MTVWMTJIOC41VjUuOTE1TDEwLjY2NjcgOEgxMkw4IDRMNCA4WiIgZmlsbD0iIzE1N0ZGMyIvPgo8L3N2Zz4K";
export { SvgAgentStatusUpgrade as ReactComponent };